import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/synchronizer`, { params: params });
	},
	store(payload) {
		return Repository.post(`/company/${company.value.id}/admin/synchronizer`, payload).then((response) => {
			toast.success(`Conexión creada correctamente.`);
			return response;
		});
	},
	show(id) {
		return Repository.get(`/company/${company.value.id}/admin/synchronizer/${id}`);
	},
	tokenCheck(id) {
		return Repository.get(`/company/${company.value.id}/admin/synchronizer/${id}/token`);
	},
	tokenCreate(id) {
		return Repository.post(`/company/${company.value.id}/admin/synchronizer/${id}/token`);
	},
	update(id, payload) {
		return Repository.put(`/company/${company.value.id}/admin/synchronizer/${id}`, payload).then((response) => {
			toast.success(`Conexión actualizada correctamente.`);
			return response;
		});
	},
	destroy(id) {
		return Repository.delete(`/company/${company.value.id}/admin/synchronizer/${id}`).then((response) => {
			toast.success(`Conexión eliminada correctamente.`);
			return response;
		});
	}
}